import React, { useMemo } from 'react';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { ErrorBox } from 'common/components/ErrorBox.tsx';
import SupportTicketLink from 'common/components/SupportTicketLink';

const TableauErrorMessage = ({ title, isShared }) => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;

  const message = useMemo(() => {
    if (isPwcUser && isShared) {
      return (
        <>
          Please <SupportTicketLink /> for assistance with this issue.
        </>
      );
    }
    if (isPwcUser && !isShared) {
      return (
        <>
          Please try again later. If the issue continues, please{' '}
          <SupportTicketLink /> for assistance.
        </>
      );
    }

    return (
      <>
        Please try again later. If the issue continues, please contact the
        Engagement Lead or Engagement Manager.
      </>
    );
  }, [isPwcUser, isShared]);

  return <ErrorBox title={title} message={message} />;
};

export default TableauErrorMessage;
